<template>
  <el-dialog title="上传图片素材" :visible.sync="visible" width="980px" :before-close="close">
    <el-upload ref="upload" action="#" multiple accept="image/png,image/jpg,image/jpeg" :file-list="fileList" :auto-upload="false">
      <el-button slot="trigger" size="small" type="primary">选取文件</el-button>

      <el-button class="button" size="small" type="warning" @click="clearFiles">清空列表</el-button>
      <el-button size="small" type="success" :loading="loading" @click="submitUpload">确认上传</el-button>

      <el-button size="small" type="text" :disabled="!images.length" @click="copyAllLink">复制全部链接</el-button>

      <div slot="tip" class="el-upload__tip">只能上传jpg/png/jpeg格式的图片</div>
    </el-upload>

    <template v-if="images.length">
      <el-table :data="images" size="small" border :height="369" style="width: 100%">
        <el-table-column label="图片" align="center" width="80">
          <template v-slot="{ row }">
            <el-popover placement="right" :append-to-body="false" :visible-arrow="true" trigger="hover">
              <div class="popover-img">
                <img class="popover-img" :src="row.img" alt="img.png" />
              </div>

              <template slot="reference">
                <img class="reference-img" :src="row.img" alt="img.png" />
              </template>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column label="链接">
          <template v-slot="{ row }">
            <div class="img-url">
              <span>{{ row.imgUrl }}</span>
              <i class="copy el-icon-document-copy" @click="() => copyImgUrl(row.imgUrl)" />
            </div>
          </template>
        </el-table-column>
        <el-table-column label="文件名" width="300">
          <template v-slot="{ row }">
            <div>{{ row.name }}</div>
          </template>
        </el-table-column>
      </el-table>
    </template>
  </el-dialog>
</template>

<script>
import API from '@/api'
import { copy } from '@/utils/copy'

export default {
  data() {
    return {
      visible: false,

      images: [],

      loading: false,

      fileList: [],
      updateList: []
    }
  },
  methods: {
    /**
     * API 上传文件
     *
     * @param {Array} files
     */
    async upload(files) {
      this.images = []
      this.setLoading(true)
      API.signValue({ directory: 'test/' })
        .then(({ data }) => {
          let formData = new FormData()
          formData.append('directory', 'test/')
          formData.append('signValue', data)
          files.forEach((file) => {
            formData.append('fileList', file)
          })
          API.uploadFile(formData)
            .then(({ data, code, message }) => {
              if (code === 10000) {
                let result = data.split(',').length ? data.split(',') : []
                result.forEach((item, i) => {
                  this.images.push({
                    img: item,
                    imgUrl: item,
                    name: files[i].name
                  })
                })
              } else {
                this.$message.error(message)
              }
              this.setLoading(false)
            })
            .catch((error) => {
              this.setLoading(false)
              this.$message.error(error.message)
            })
        })
        .catch((error) => {
          this.setLoading(false)
          this.$message.error(error.message)
        })
    },

    /**
     * 设置上传中的Loading
     */
    setLoading(flag) {
      this.loading = flag
    },

    /**
     * 确认上传
     */
    submitUpload() {
      if (this.$refs.upload.uploadFiles.length) {
        this.updateList = []
        this.$refs.upload.uploadFiles.forEach((file) => {
          this.updateList.push(file.raw)
        })
        this.upload(this.updateList)
      } else {
        this.$message.warning('请选择需要上传的图片！')
      }
    },

    /**
     * 清空已上传的文件列表
     */
    clearFiles() {
      this.$refs.upload.clearFiles()
    },

    /**
     * 复制全部链接
     */
    copyAllLink() {
      let urls = this.images.map((item) => item.imgUrl)
      urls = urls.join('\n')
      if (urls) {
        copy(urls)
      } else {
        this.$message.warning('复制出错，请重新操作！')
      }
    },

    /**
     * 拷贝链接
     */
    copyImgUrl(url) {
      copy(url)
    },

    show() {
      this.visible = true
    },

    /**
     * 关闭对话框
     */
    close() {
      this.visible = false
      this.images = []
      this.fileList = []
      this.updateList = []
    }
  }
}
</script>

<style lang="scss" scoped>
.button {
  margin-left: 10px;
}

/deep/.el-upload-list {
  max-height: 128px;
  overflow: auto;
}

.el-table {
  margin-top: 15px;
}

.popover-img {
  height: 168px;
  width: 168px;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 4px;
  }
}

.reference-img {
  width: 58px;
  height: 58px;
  object-fit: cover;
  border-radius: 4px;
  cursor: pointer;
}

.img-url {
  .copy {
    color: #99c41c;
    margin-left: 5px;
    cursor: pointer;
  }
}
</style>
